"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    transition-property: background, border, box-shadow, color;\n    width: 100%;\n    height: 100%;\n    // IOS Safari UserAgent style\n    margin: 0;\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  var palette = theme.palette;
  return {
    fontSize: theme.fontSize,
    lineHeight: theme.lineHeight,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight,
    paddingTop: theme.paddingTop,
    paddingRight: theme.paddingRight,
    paddingBottom: theme.paddingBottom,
    paddingLeft: theme.paddingLeft,
    borderRadius: theme.borderRadius,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    wordBreak: theme.wordBreak,
    color: theme.color,
    background: theme.background,
    boxShadow: theme.boxShadow,
    whiteSpace: theme.whiteSpace,
    borderStyle: theme.borderStyle,
    borderWidth: theme.borderWidth,
    borderColor: theme.borderColor,
    // IOS Safari UserAgent style
    margin: 0,
    '& a': {
      color: theme.color
    },
    '&:focus': {
      outline: '0 none',
      color: theme.focusColor,
      borderColor: theme.focusBorderColor,
      backgroundColor: theme.focusBackground,
      boxShadow: theme.focusBoxShadow
    },
    '&:hover': {
      color: theme.hoverColor,
      borderColor: theme.hoverBorderColor,
      backgroundColor: theme.hoverBackground,
      boxShadow: theme.hoverBoxShadow,
      cursor: disabled ? 'not-allowed' : 'pointer'
    },
    '&:active': {
      color: theme.activeColor,
      borderColor: theme.activeBorderColor,
      backgroundColor: theme.activeBackground,
      boxShadow: theme.activeBoxShadow
    },
    '&[disabled]': {
      color: theme.disabledColor,
      borderColor: theme.disabledBorderColor,
      backgroundColor: theme.disabledBackground,
      boxShadow: theme.disabledBoxShadow
    }
  };
};

var Button = _styledComponents["default"].button(_templateObject(), function (props) {
  return base(props);
});

var _default = Button;
exports["default"] = _default;